import { useEffect, useRef } from "react";

const SMOOTHING_FACTOR = 0.1;
const MOVEMENT_SCALE = 0.12;
const STATIC_POSITION = { x: 0, y: 0 };

export function useMouseTracking() {
  const mousePositionRef = useRef({ x: 0, y: 0 });
  const currentPositionRef = useRef({ x: 0, y: 0 });
  const imageRef = useRef(null);
  const containerRef = useRef(null);
  const animationFrameRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const container = containerRef.current;
      if (container) {
        const rect = container.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        mousePositionRef.current.x = e.clientX - centerX;
        mousePositionRef.current.y = e.clientY - centerY;
      }
    };

    const handleMouseLeave = () => {
      mousePositionRef.current.x = 0;
      mousePositionRef.current.y = 0;
    };

    const animate = () => {
      const target = mousePositionRef.current;
      const current = currentPositionRef.current;

      current.x += (target.x - current.x) * SMOOTHING_FACTOR;
      current.y += (target.y - current.y) * SMOOTHING_FACTOR;

      if (imageRef.current) {
        imageRef.current.style.transform = `translate(${
          current.x * MOVEMENT_SCALE
        }px, ${current.y * MOVEMENT_SCALE}px)`;
      }

      animationFrameRef.current = requestAnimationFrame(animate);
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener("mousemove", handleMouseMove);
      container.addEventListener("mouseleave", handleMouseLeave);
      animationFrameRef.current = requestAnimationFrame(animate);
    }

    return () => {
      if (container) {
        container.removeEventListener("mousemove", handleMouseMove);
        container.removeEventListener("mouseleave", handleMouseLeave);
      }
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, []);

  return { position: STATIC_POSITION, imageRef, containerRef };
}
